"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentInfo = void 0;
var AppointmentInfo_1 = require("./AppointmentInfo");
Object.defineProperty(exports, "AppointmentInfo", { enumerable: true, get: function () { return AppointmentInfo_1.AppointmentInfo; } });
//# sourceMappingURL=index.js.map